import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading, Reveal } from "./primitives";

const FAQS = [
    {
        q: "What does “guaranteed delivery” actually mean?",
        a: "Every event is written to a durable, replicated log before MDH acknowledges your publish call. From there, deliveries retry with exponential backoff for up to 24 hours. If an endpoint never recovers, the event is parked — never dropped — and can be replayed manually or via API.",
    },
    {
        q: "How do my endpoints verify events are really from MDH?",
        a: "Every delivery carries an X-MDH-Signature header: an HMAC-SHA256 of the timestamped payload, signed with your endpoint's secret. Keys rotate automatically with overlap windows, and our SDKs verify signatures in one function call.",
    },
    {
        q: "Can I replay or inspect past events?",
        a: "Yes. The command center keeps a full delivery trail per endpoint — request, response, latency, and attempt history. Any event can be replayed to the same endpoint or a staging URL, with the original idempotency key preserved.",
    },
    {
        q: "How hard is it to migrate from Svix, or from Stripe-style in-house webhooks?",
        a: "Most teams migrate in an afternoon. The REST API mirrors the conventions you already know, and we provide import tooling for existing endpoint registries. Dual-publish mode lets you run old and new side by side until you cut over.",
    },
    {
        q: "What happens if I exceed my plan's event volume?",
        a: "Nothing breaks. We keep delivering and notify you at 80% and 100% of quota. Overage is billed at a flat per-million rate on Pro and Scale, or you can upgrade in place — prorated instantly.",
    },
    {
        q: "Where is my data processed?",
        a: "MDH runs across 35 edge regions with regional pinning available on Scale and Enterprise. Event payloads are encrypted at rest and in transit, and Enterprise plans support EU-only or dedicated-VPC deployments.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative border-t border-slate-800/70 py-24 lg:py-32"
        >
            <div className="mx-auto max-w-3xl px-5 lg:px-8">
                <SectionHeading
                    testid="faq"
                    eyebrow="FAQ"
                    title="Answers, before you ask."
                    align="center"
                />
                <Reveal delay={0.15} className="mt-12">
                    <Accordion type="single" collapsible className="w-full">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-slate-800/80"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${i}`}
                                    className="text-left font-display text-sm font-bold tracking-tight text-slate-200 hover:text-cyan-300 hover:no-underline sm:text-base"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    data-testid={`faq-content-${i}`}
                                    className="text-xs leading-relaxed text-slate-400 sm:text-sm"
                                >
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
